// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (-webkit-min-device-pixel-ratio:0){input[data-v-5a7d00fc],select[data-v-5a7d00fc],textarea[data-v-5a7d00fc]{font-size:16px}}.hide-extra i[data-v-5a7d00fc]{color:#000;font-size:15px;position:absolute;right:0}.ps-panel--sidebar[data-v-5a7d00fc]{font-size:18px}.ps-panel--sidebar .v-list-group__header a[data-v-5a7d00fc]{font-weight:600}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
